
<app-loading *ngIf="cargandoMatriz"></app-loading>

<div class="politica-matriz" *ngIf="!cargandoMatriz">
  <form [formGroup]="matrizForm" (ngSubmit)="onSubmitMatriz(true)">
    <h3 class="politica-matriz-header" [ngClass]="{'politica-matriz-header--modalidad': !matrizGeneral}">
      {{ !matrizGeneral ? matriz.matriz : 'POLITICAS.LBL_MATRIZGENERAL' | translate }}
    </h3>
    <table class="politica-matriz-table">
      <thead>
        <tr>
          <th *ngFor="let columna of columnasMatriz">{{ columna.header | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ 'POLITICAS.LBL_TITULAR' | translate }}</td>
          <td>
            <input type="text" name="valorTitular1" id="valorTitular1" maxlength="2" numero-entero-reactive formControlName="valorTitular1" *ngIf="!editarMatriz && !esDetalle">
            <div class="p-message p-messages-error p-corner-all" *ngIf="submittedMatrizGeneral && fMatriz.valorTitular1.invalid">
              {{ 'LBL_REQUERIDO' | translate }}
            </div>

            <div *ngIf="editarMatriz || esDetalle">
              <label class="falso-combo-texto" [ngClass]="{'disabled': editarMatriz || esDetalle}">
                {{ fMatriz.valorTitular1.value }}</label
              >
            </div>
          </td>
          <td>
            <input type="text" name="valorDeudor1" id="valorDeudor1" maxlength="2" numero-entero-reactive formControlName="valorDeudor1" *ngIf="!editarMatriz && !esDetalle">
            <div class="p-message p-messages-error p-corner-all" *ngIf="submittedMatrizGeneral && fMatriz.valorDeudor1.invalid">
              {{ 'LBL_REQUERIDO' | translate }}
            </div>

            <div *ngIf="editarMatriz || esDetalle">
              <label class="falso-combo-texto" [ngClass]="{'disabled': editarMatriz || esDetalle}">
                {{ fMatriz.valorDeudor1.value }}</label
              >
            </div>
          </td>
          <td>
            <input type="text" name="valorCodeudor1" id="valorCodeudor1" maxlength="2" numero-entero-reactive formControlName="valorCodeudor1" *ngIf="!editarMatriz && !esDetalle">
            <div class="p-message p-messages-error p-corner-all" *ngIf="submittedMatrizGeneral && fMatriz.valorCodeudor1.invalid">
              {{ 'LBL_REQUERIDO' | translate }}
            </div>

            <div *ngIf="editarMatriz || esDetalle">
              <label class="falso-combo-texto" [ngClass]="{'disabled': editarMatriz || esDetalle}">
                {{ fMatriz.valorCodeudor1.value }}</label
              >
            </div>
          </td>
        </tr>
        <tr>
          <td>{{ 'POLITICAS.LBL_SOLIDARIO' | translate }}</td>
          <td>
            <input type="text" name="valorTitular2" id="valorTitular2" maxlength="2" numero-entero-reactive formControlName="valorTitular2" *ngIf="!editarMatriz && !esDetalle">
            <div class="p-message p-messages-error p-corner-all" *ngIf="submittedMatrizGeneral && fMatriz.valorTitular2.invalid">
              {{ 'LBL_REQUERIDO' | translate }}
            </div>

            <div *ngIf="editarMatriz || esDetalle">
              <label class="falso-combo-texto" [ngClass]="{'disabled': editarMatriz || esDetalle}">
                {{ fMatriz.valorTitular2.value }}</label
              >
            </div>
          </td>
          <td>
            <input type="text" name="valorDeudor2" id="valorDeudor2" maxlength="2" numero-entero-reactive formControlName="valorDeudor2" *ngIf="!editarMatriz && !esDetalle">
            <div class="p-message p-messages-error p-corner-all" *ngIf="submittedMatrizGeneral && fMatriz.valorDeudor2.invalid">
              {{ 'LBL_REQUERIDO' | translate }}
            </div>

            <div *ngIf="editarMatriz || esDetalle">
              <label class="falso-combo-texto" [ngClass]="{'disabled': editarMatriz || esDetalle}">
                {{ fMatriz.valorDeudor2.value }}</label
              >
            </div>
          </td>
          <td>
            <input type="text" name="valorCodeudor2" id="valorCodeudor2" maxlength="2" numero-entero-reactive formControlName="valorCodeudor2" *ngIf="!editarMatriz && !esDetalle">
            <div class="p-message p-messages-error p-corner-all" *ngIf="submittedMatrizGeneral && fMatriz.valorCodeudor2.invalid">
              {{ 'LBL_REQUERIDO' | translate }}
            </div>

            <div *ngIf="editarMatriz || esDetalle">
              <label class="falso-combo-texto" [ngClass]="{'disabled': editarMatriz || esDetalle}">
                {{ fMatriz.valorCodeudor2.value }}</label
              >
            </div>
          </td>
        </tr>
        <tr>
          <td>{{ 'POLITICAS.LBL_CODEUDOR' | translate }}</td>
          <td>
            <input type="text" name="valorTitular3" id="valorTitular3" maxlength="2" numero-entero-reactive formControlName="valorTitular3" *ngIf="!editarMatriz && !esDetalle">
            <div class="p-message p-messages-error p-corner-all" *ngIf="submittedMatrizGeneral && fMatriz.valorTitular3.invalid">
              {{ 'LBL_REQUERIDO' | translate }}
            </div>

            <div *ngIf="editarMatriz || esDetalle">
              <label class="falso-combo-texto" [ngClass]="{'disabled': editarMatriz || esDetalle}">
                {{ fMatriz.valorTitular3.value }}</label
              >
            </div>
          </td>
          <td>
            <input type="text" name="valorDeudor3" id="valorDeudor3" maxlength="2" numero-entero-reactive formControlName="valorDeudor3" *ngIf="!editarMatriz && !esDetalle">
            <div class="p-message p-messages-error p-corner-all" *ngIf="submittedMatrizGeneral && fMatriz.valorDeudor3.invalid">
              {{ 'LBL_REQUERIDO' | translate }}
            </div>

            <div *ngIf="editarMatriz || esDetalle">
              <label class="falso-combo-texto" [ngClass]="{'disabled': editarMatriz || esDetalle}">
                {{ fMatriz.valorDeudor3.value }}</label
              >
            </div>
          </td>
          <td>
            <input type="text" name="valorCodeudor3" id="valorCodeudor3" maxlength="2" numero-entero-reactive formControlName="valorCodeudor3" *ngIf="!editarMatriz && !esDetalle">
            <div class="p-message p-messages-error p-corner-all" *ngIf="submittedMatrizGeneral && fMatriz.valorCodeudor3.invalid">
              {{ 'LBL_REQUERIDO' | translate }}
            </div>

            <div *ngIf="editarMatriz || esDetalle">
              <label class="falso-combo-texto" [ngClass]="{'disabled': editarMatriz || esDetalle}">
                {{ fMatriz.valorCodeudor3.value }}</label
              >
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="politica-matriz-form" *ngIf="!matrizGeneral">
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <p-checkbox label="{{ 'POLITICAS.LBL_EXCLUIRCONTEO' | translate}}" binary="true"
                      id="indicadorExcluidaddelConteo"
                      name="indicadorExcluidaddelConteo"
                      formControlName="indicadorExcluidaddelConteo" [disabled]="editarMatriz || esDetalle"></p-checkbox>
        </div>
      </div>
    </div>
    <div class="politica-matriz-options">
      <button
        *ngIf="!matrizGeneral && !esDetalle"
        class="button-transparent"
        label="{{ 'BTN_ELIMINAR' | translate }}"
        pButton
        type="button"
        (click)="deshabilitarMatriz()"
      ></button>
      <button
        *ngIf="editarMatriz && !esDetalle"
        class="button-transparent"
        label="{{ 'BTN_EDITAR' | translate }}"
        pButton
        type="button"
        (click)="habilitarEdicion()"
      ></button>
      <button
        *ngIf="!editarMatriz && !esDetalle"
        class="button-transparent"
        label="{{ 'BTN_GUARDAR' | translate }}"
        type="submit"
        pButton
      ></button>
    </div>
  </form>
</div>

<p-confirmDialog #cd [key]="matriz.matriz" *ngIf="matriz && matriz.matriz">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
